import { Routes } from '@angular/router';

/** Production/UAT/HLG variant: no prototype routes, no lazy chunk. */
export const PROTOTYPES_APP_ROUTES: Routes = [];
